import toast from "react-hot-toast";
import  {client} from "@/app/ApolloClient";
import {gql} from "@apollo/client";


export var gqlSetAssetPrimaryImageId = gql`
  mutation setAssetPrimaryImage($organizationId: UUID!,$assetId: UUID!, $imageId: UUID!) {
    setAssetPrimaryImage(organizationId: $organizationId, assetId: $assetId, imageId: $imageId) 
  }  
`;

export function apiSetAssetPrimaryImageId(organizationId, assetId, imageId) {

    return new Promise(async (resolve, reject) => {
        if(!organizationId) reject("organizationId is required");
        client
            .mutate({
                mutation: gqlSetAssetPrimaryImageId,
                variables: {organizationId, assetId, imageId},
                errorPolicy: "ignore",
                fetchPolicy: "network-only"
            })
            .then((result) => {
                let data = result.data.setAssetPrimaryImage;
                if(data) resolve(data);
                else throw "Unable to set";
            })
            .catch((err) => {
                toast.error("Api Error, Unable to set primary image");
                reject(err);
            })
    });
}
